/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/id-card
 */
import { default as DefaultIcon } from '~icons/lucide/id-card';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const IdCardIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
